<template>
    <v-card>
        <v-card-title><v-icon>mdi-login</v-icon> Login / Register</v-card-title>
        <v-card-text class="text-left">
            <v-skeleton-loader
            :loading="awaitingResponse"
            type="paragraph"
            >
                <h3>Login is required to enable basket checkout</h3>
                <br>
                <p>
                    If you are not yet registered as part of the GUTS collaboration,
                    <a @click="requestRegistration()" class="register-link">request registration</a>
                    with your institutional email address.
                </p>
            </v-skeleton-loader>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="closeDialog"><v-icon>mdi-cancel</v-icon> Cancel</v-btn>
            <v-btn @click="loginSRAM"><v-icon>mdi-login</v-icon> Log in</v-btn>
        </v-card-actions>
    </v-card>

</template>

<script setup>
    import { inject, ref } from 'vue'
    import { useAuth } from '@/composables/auth.js';

    const userInfo = inject('userInfo')
    const isAuthenticated = inject('isAuthenticated')
    const awaitingResponse = ref(false)
    const backendUrl = inject('VITE_BACKEND_API_URL')
    const { login } = useAuth(userInfo, isAuthenticated, backendUrl);
    const emit = defineEmits(['close-dialog']);

    const registrationUrl = "https://sram.surf.nl/registration?collaboration=5ea5147b-eecc-4a14-9708-6f0640e27c20";

    const closeDialog = () => {
        // Tell parent to close the dialog that contains this component
        emit('close-dialog');
    };

    const requestRegistration = () => {
        window.open(registrationUrl, '_blank');
    }

    async function loginSRAM() {
        try {
            emit('close-dialog');
            await login();
        } catch (error) {
            console.error('Login failed:', error);
        }
    }

</script>

<style scoped>

 .register-link {
    color: #ff00fb;
    text-decoration: underline;
    cursor: pointer;
 }

</style>